/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/dataentry/dataentry.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from "@angular/core";
import { DataentryRoutingModule } from "./dataentry-routing.module";
import * as i0 from "@angular/core";
export class DataentryModule {
    constructor() {
    }
}
DataentryModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    DataentryRoutingModule,
                ],
            },] },
];
/** @nocollapse */
DataentryModule.ctorParameters = () => [];
/** @nocollapse */ DataentryModule.ɵmod = i0.ɵɵdefineNgModule({ type: DataentryModule });
/** @nocollapse */ DataentryModule.ɵinj = i0.ɵɵdefineInjector({ factory: function DataentryModule_Factory(t) { return new (t || DataentryModule)(); }, imports: [[
            DataentryRoutingModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DataentryModule, { imports: [DataentryRoutingModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DataentryModule, [{
        type: NgModule,
        args: [{
                imports: [
                    DataentryRoutingModule,
                ],
            }]
    }], function () { return []; }, null); })();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0YWVudHJ5Lm1vZHVsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uLy4uL3Zpc2lvbmljcy9uZy9zcmMvYXBwL2RhdGFlbnRyeS9kYXRhZW50cnkubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsT0FBTyxFQUFDLFFBQVEsRUFBQyxNQUFNLGVBQWUsQ0FBQztBQUN2QyxPQUFPLEVBQUMsc0JBQXNCLEVBQUMsTUFBTSw0QkFBNEIsQ0FBQzs7QUFPbEUsTUFBTSxPQUFPLGVBQWU7SUFDMUI7SUFBZSxDQUFDOzs7WUFOakIsUUFBUSxTQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixzQkFBc0I7aUJBQ3ZCO2FBQ0Y7Ozs7bURBQ1ksZUFBZTs2R0FBZixlQUFlLGtCQUpoQjtZQUNSLHNCQUFzQjtTQUN2Qjt3RkFFVSxlQUFlLGNBSHhCLHNCQUFzQjtrREFHYixlQUFlO2NBTDNCLFFBQVE7ZUFBQztnQkFDUixPQUFPLEVBQUc7b0JBQ1Isc0JBQXNCO2lCQUN2QjthQUNGIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtOZ01vZHVsZX0gZnJvbSBcIkBhbmd1bGFyL2NvcmVcIjtcbmltcG9ydCB7RGF0YWVudHJ5Um91dGluZ01vZHVsZX0gZnJvbSBcIi4vZGF0YWVudHJ5LXJvdXRpbmcubW9kdWxlXCI7XG5cbkBOZ01vZHVsZSh7XG4gIGltcG9ydHMgOiBbXG4gICAgRGF0YWVudHJ5Um91dGluZ01vZHVsZSxcbiAgXSxcbn0pXG5leHBvcnQgY2xhc3MgRGF0YWVudHJ5TW9kdWxlIHtcbiAgY29uc3RydWN0b3IoKSB7fVxufVxuIl19